import { AxiosResponse } from 'axios';

export interface NotificationService {
  getNotifications: (userId: string) => Promise<GetNotificationsResponse>;
  setNotificationsStatus: (
    userId: string,
    notificationsStatus: SetNotificationsRequest[]
  ) => Promise<SetNotificationsStatusResponse>;
  setReadAll: (userId: string) => Promise<SetReadAllResponse>;
}

export enum NotificationStatus {
  Read = 'Read',
  Unread = 'Unread',
  Deleted = 'Deleted',
}

export type Notification = {
  notificationId: string;
  createdAt: string;
  userId: string;
  eventType: string;
  status: NotificationStatus;
  data: string;
};

export type GetNotificationsResponse = AxiosResponse<{
  message: string;
  status: string;
  data: Notification[];
}>;

export type SetNotificationsStatusResponse = AxiosResponse<{
  message: string;
  status: string;
  data: boolean;
}>;

export type SetNotificationsRequest = {
  notificationId: string;
  status: NotificationStatus;
};

export type SetReadAllResponse = AxiosResponse<{
  message: string;
  status: string;
  data: boolean;
}>;
